import React from 'react'
// import NoData from '../../components/NoData/NoData'
import { Line } from 'react-chartjs-2'

function InflowVsOutFlowChart({ inflowHistory, outflowHistory, chartData, theme }) {
  return (
    <div className="rounded-lg p-5 mt-8" style={{ color: theme.colors.text.primary, backgroundColor: theme.colors.background.secondary }}>
    <h3 className="text-lg font-bold mb-4">Inflow vs Outflow</h3>
    <div style={{ height: "300px" }}>
      {(inflowHistory.length === 0 && outflowHistory.length === 0) ? (
        <div>No data available</div>
      ) : (
        <Line
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "top",
              },
              title: {
                display: true,
                text: "Inflow and Outflow History",
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  color: theme.colors.border,
                },
                beginAtZero: true,
              },
            },
          }}
        />
      )}
    </div>
  </div>
  )
}

export default InflowVsOutFlowChart